import Vue from 'vue'
import VueRouter from 'vue-router'

function _import(file) {
  return () => import(/* webpackChunkName: "about" */ '../views/' + file + '.vue')
}

Vue.use(VueRouter)


export const routes = [

  {path: '/', name: 'home', redirect: '/login', component: _import('layout/index')},
  {path: '/login', name: 'login', component: _import('login/index'), meta: {hidden: true}},
  {path: '/mobile/:id', name: 'mobile', component: _import('mobile/index'), meta: {hidden: true}},
  { path: '/404', component: _import('404/index') },

]


export const asyncRoutes = [
  {
    path: '/app', component: _import('layout/index'), redirect1: '/app/areamanage', name: 'app',
    children: [
      // {path: '/app/homepage', name: 'homepage', component: _import('homepage/index'),meta:{hidden: true}},
      {path: '/app/areamanage', name: 'areamanage', component: _import('gdMap/index'),meta:{catch: false}},
      {path: '/app/trajectorymonitor', name: 'trajectorymonitor', component: _import('gdMap/Marker')},
      {path: '/app/trajectorytrends', name: 'trajectorytrends', component: _import('gdMap/Trajectory'),meta:{hidden: true}},
      {path: '/app/stockManage', name: 'stockManage', component: _import('gdMap/stockList'),},
      {path: '/app/putAssetsManage', name: 'putAssetsManage', component: _import('gdMap/assetsIndex'),},
      {path: '/app/privedAssetsManage', name: 'privedAssetsManage', component: _import('gdMap/assetsProvideIndex'),},
      {path: '/app/userinfo', name: 'userinfo', component: _import('systemManage/personalCenter/index'),},
      {path: '/app/menumanage', name: 'menumanage', component: _import('systemManage/menu/index'),},
      {path: '/app/organization', name: 'organization', component: _import('systemManage/organization/index'),},
      {path: '/app/character', name: 'character', component: _import('systemManage/character/index'),},
      {path: '/app/user', name: 'user', component: _import('systemManage/usermanage/index'),},
      {path: '/app/provideAssets', name: 'provideAssets', component: _import('gdMap/provideList'),meta:{hidden: true}},
      {path: '/app/assetsUpdate', name: 'assetsUpdate', component: _import('gdMap/assetsUpdate'),meta:{hidden: true}},
      {path: '/app/seeClockinRecord', name: 'seeClockinRecord', component: _import('gdMap/clockinRecordIndex'),meta:{hidden: true}},
      {path: '/app/clock', name: 'clock', component: _import('gdMap/clockinList'),meta:{hidden: true}},
      {path: '/app/clockinstatics', name: 'clockinstatics', component: _import('gdMap/clockinstatics'),meta:{hidden: true}},
    ]
  }
]

export const menus = [
  // {title: '首页', name: 'homepage', meta: {icon: 'homepage'}},
  {
      title: '区域管理', name: 'areamanage',
      meta: {
          icon: 'workbench'

      }
  },
  {
    title: '轨迹管理', name: 'trajectorymanage',
    meta: {
      icon: 'operaterule'

    },
    children: [
        {title: '轨迹监测', name: 'trajectorymonitor'},
    ]
  },

  {
    title: '资产管理', name: 'assetsmanage',
    meta:{
      icon:'assetsmanage'

    },
    children: [
      {title: '库存管理', name: 'stockManage'},
      {title: '入库管理', name: 'putAssetsManage'},
      {title: '出库管理', name: 'privedAssetsManage'},
    ]
  },
  {
    title: '考勤管理', name: 'clockinmanage',
    meta:{
      icon:'clockinmanage'

    },
    children: [
      {title: '打卡管理', name: 'clock'},
    ]
  },
  {
    title: '权限管理', name: 'systemconfig',
    meta: {
      icon: 'systemconfig'

    }, children: [
      {title: '功能菜单', name: 'menumanage'},
      {title: '组织机构', name: 'organization'},
      {title: '角色管理', name: 'character'},
      {title: '用户管理', name: 'user'},
    ]
  },
  {
    title: '个人信息', name: 'userinfo', meta: {
      icon: 'userinfo'

    },
  },
]

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
